import { render, staticRenderFns } from "./sales-by-customer-class.vue?vue&type=template&id=6646d88e&scoped=true&"
import script from "./sales-by-customer-class.vue?vue&type=script&lang=js&"
export * from "./sales-by-customer-class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646d88e",
  null
  
)

export default component.exports